import { render, staticRenderFns } from "./companyRecruit.vue?vue&type=template&id=06797ac4&scoped=true"
import script from "./companyRecruit.vue?vue&type=script&lang=js"
export * from "./companyRecruit.vue?vue&type=script&lang=js"
import style0 from "./companyRecruit.vue?vue&type=style&index=0&id=06797ac4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06797ac4",
  null
  
)

export default component.exports